<template>
    <section class="content-section container why-us px-3">
        <h2 class="content-section-title">WHY US</h2>
        <div class="sub-title-wrap">
            <p>Because we are the professional manufacturer for car wiper blade, and we believe that business is more than just business, it is a partnership built on a win-win- basis.</p>
            <p>Here is our SPEED theory which might persuade you to choose us as your partner:</p>
        </div>
        <b-row>
            <Itmes v-for="(data, i) in info" :key="i" :data="data" :idx="i" />
        </b-row>
    </section>
</template>

<script>
import Itmes from './item.vue';

export default {
    components: { Itmes },
    data() {
        return {
            info: [
                {
                    title: 'SERVICE',
                    desc: 'Stable quality, fast delivery, reasonable price and perfect service, etc.'
                },
                {
                    title: 'PATENT',
                    desc: 'Hundreds of patented technologies'
                },
                {
                    title: 'EQUIPMENT',
                    desc: 'Intelligent equipment and management'
                },
                {
                    title: 'EXPERIENCE',
                    desc: '35 years of manufacturing experience and cooperation with many international brands'
                },
                {
                    title: 'DEVELOPMENT',
                    desc: 'Research and develop new products according to customer requirements'
                }
            ]
        }
    }
}
</script>

<style lang="scss" scope>
    .why-us{
        .sub-title-wrap {
            max-width: 700px;
            margin: 0 auto 50px;
            text-align: center;
            
            p {
                font-size: 18px;
            }
        }
    }
</style>